import React, { Component } from 'react';
import ReactTable from "react-table";
import "react-table/react-table.css";

import MenuComponent2 from './MenuComponent2';

import ImportItemService from '../services/ImportItemService';
import AuthenticationService from '../services/AuthenticationService';

class ImportedItemList extends Component {
  constructor () {
    super();
    this.state = {
      importedItemList: [],
      columns : [{
            Header: 'ID',
            accessor: 'id',
            width: 200,
            Cell: e =><a href={e.value}> {e.value} </a>
        },{
            Header: 'Order No',
            accessor: 'orderNo'
        },{
            Header: 'Status',
            accessor: 'status'
        },{            
        },{
            Header: 'Action',
            accessor: 'action',
            width: 100,
            Cell: row =>(
                <div>
                    <button onClick={() => this.handleDelete(row.original)}>Delete</button>
                </div>
            )
      }]
    };
  }

  componentDidMount () {
    ImportItemService.retrieveAllImportedItems().then(data => {
        this.setState({ importedItemList:  data})
      });
      console.log(this.state.importedItemList);
  }

  handleDelete(e){
    this.props.history.push("/importItems/delete/" + e.id);
  }

  render() {
    if (!AuthenticationService.isAdmin() && !AuthenticationService.isService()){
      return (<div>Unauthorized access.</div>);
    }
    return (
          <div>
              <MenuComponent2/>
              <ReactTable
                data={this.state.importedItemList}
                columns={this.state.columns}
                defaultPageSize = {5}
                pageSizeOptions = {[5,8,13]}
              />
          </div>      
    )
  }
}

export default ImportedItemList;